document.addEventListener('DOMContentLoaded', function () {
  // Select both desktop and mobile wrappers
  const popupGliderWrappers = document.querySelectorAll('.popup-glider-wrapper, .popup-glider-wrapper-mobile');
  const robocapUpgradeGlider = document.querySelector('.robocap--upgrade-glider');
  
  function updateGliderWrapperVisibility() {
    // console.log('Updating glider wrapper visibility');
      const popupGliderWrapper = document.querySelector('.popup-glider-wrapper');
    
    if (robocapUpgradeGlider && robocapUpgradeGlider.classList.contains('active')) {
      if (popupGliderWrapper) {
        popupGliderWrapper.style.display = 'none';
      }
    } else {
      if (popupGliderWrapper) {
        popupGliderWrapper.style.display = 'block';
      }
    }
  }
  
  updateGliderWrapperVisibility();
  
  if (robocapUpgradeGlider) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          updateGliderWrapperVisibility();
        }
      });
    });
    
    observer.observe(robocapUpgradeGlider, { 
      attributes: true 
    });
  }

  if (popupGliderWrappers.length > 0) {
    // Apply to each wrapper (desktop and mobile)
    popupGliderWrappers.forEach(wrapper => {
      wrapper.innerHTML = `
        <div class="popup-glider-content">
          <div class="popup-glider-icon-wrapper">
          <div class="popup-glider-icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_398_3965)">
            <path d="M8.00431 5.0705V8.0045M8.00431 8.0045V10.9385M8.00431 8.0045H10.9383M8.00431 8.0045H5.07031" stroke="#352B27" stroke-linecap="round" />
            <path d="M8.00492 15.3382C12.0559 15.3382 15.3399 12.0542 15.3399 8.00315C15.3399 3.95214 12.0559 0.668152 8.00492 0.668152C3.95391 0.668152 0.669922 3.95214 0.669922 8.00315C0.669922 12.0542 3.95391 15.3382 8.00492 15.3382Z" stroke="#352B27" />
          </g>
          <defs>
            <clipPath id="clip0_398_3965">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
            </svg>
          </div>
          <div class="popup-glider-text">
            Upgrade to the Glider for <span style="text-decoration: line-through; color: #756F6D;">P195</span> P100
            <span style="font-size: 11px; color: #756F6D; display: block; margin-top: -5px;">retractable stainless steel straw</span>
          </div>
        </div>
      `;

      const popupGliderContent = wrapper.querySelector('.popup-glider-content');

      if (popupGliderContent) {
        popupGliderContent.addEventListener('click', function (e) {
          e.preventDefault();
          
          // Get all content elements and toggle active class on all of them
          const allGliderContents = document.querySelectorAll('.popup-glider-content');
          allGliderContents.forEach(content => {
            content.classList.toggle('active');
            
            const gliderIcon = content.querySelector('.popup-glider-icon');
            if (gliderIcon) {
              if (content.classList.contains('active')) {
                gliderIcon.innerHTML = `
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99996 0.666687C3.94996 0.666687 0.666626 3.95002 0.666626 8.00002C0.666626 12.05 3.94996 15.3334 7.99996 15.3334C12.05 15.3334 15.3333 12.05 15.3333 8.00002C15.3333 3.95002 12.05 0.666687 7.99996 0.666687ZM11.1786 6.76002C11.2372 6.69312 11.2817 6.61518 11.3097 6.5308C11.3377 6.44642 11.3485 6.3573 11.3415 6.26868C11.3345 6.18006 11.3099 6.09373 11.269 6.01477C11.2282 5.93582 11.1719 5.86582 11.1037 5.80892C11.0354 5.75201 10.9564 5.70933 10.8714 5.6834C10.7863 5.65746 10.697 5.6488 10.6085 5.65791C10.5201 5.66702 10.4344 5.69372 10.3565 5.73644C10.2785 5.77917 10.2099 5.83705 10.1546 5.90669L7.28796 9.34602L5.80463 7.86202C5.67889 7.74058 5.51049 7.67339 5.33569 7.6749C5.16089 7.67642 4.99369 7.74654 4.87008 7.87014C4.74648 7.99375 4.67636 8.16096 4.67484 8.33575C4.67332 8.51055 4.74052 8.67895 4.86196 8.80469L6.86196 10.8047C6.92746 10.8702 7.00589 10.9213 7.09224 10.9547C7.17858 10.9882 7.27096 11.0033 7.36347 10.9991C7.45599 10.9949 7.54661 10.9715 7.62957 10.9303C7.71252 10.8892 7.78599 10.8312 7.84529 10.76L11.1786 6.76002Z" fill="#352b27"/>
                  </svg>
                `;
                content.style.opacity = '0.7';
              } else {
                gliderIcon.innerHTML = `
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_398_3965)">
                      <path d="M8.00431 5.0705V8.0045M8.00431 8.0045V10.9385M8.00431 8.0045H10.9383M8.00431 8.0045H5.07031" stroke="#352B27" stroke-linecap="round" />
                      <path d="M8.00492 15.3382C12.0559 15.3382 15.3399 12.0542 15.3399 8.00315C15.3399 3.95214 12.0559 0.668152 8.00492 0.668152C3.95391 0.668152 0.669922 3.95214 0.669922 8.00315C0.669922 12.0542 3.95391 15.3382 8.00492 15.3382Z" stroke="#352B27" />
                    </g>
                    <defs>
                      <clipPath id="clip0_398_3965">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                `;
                content.style.opacity = '';
              }
            }
          });

          // Handle the robocap upgrade glider
          const isActive = this.classList.contains('active');
          
          if (robocapUpgradeGlider) {
            if (isActive) {
              robocapUpgradeGlider.style.display = 'none';
              
              const gliderAction = robocapUpgradeGlider.querySelector('.upgrade-glider-action');
              if (gliderAction) {
                gliderAction.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99996 0.666687C3.94996 0.666687 0.666626 3.95002 0.666626 8.00002C0.666626 12.05 3.94996 15.3334 7.99996 15.3334C12.05 15.3334 15.3333 12.05 15.3333 8.00002C15.3333 3.95002 12.05 0.666687 7.99996 0.666687ZM11.1786 6.76002C11.2372 6.69312 11.2817 6.61518 11.3097 6.5308C11.3377 6.44642 11.3485 6.3573 11.3415 6.26868C11.3345 6.18006 11.3099 6.09373 11.269 6.01477C11.2282 5.93582 11.1719 5.86582 11.1037 5.80892C11.0354 5.75201 10.9564 5.70933 10.8714 5.6834C10.7863 5.65746 10.697 5.6488 10.6085 5.65791C10.5201 5.66702 10.4344 5.69372 10.3565 5.73644C10.2785 5.77917 10.2099 5.83705 10.1546 5.90669L7.28796 9.34602L5.80463 7.86202C5.67889 7.74058 5.51049 7.67339 5.33569 7.6749C5.16089 7.67642 4.99369 7.74654 4.87008 7.87014C4.74648 7.99375 4.67636 8.16096 4.67484 8.33575C4.67332 8.51055 4.74052 8.67895 4.86196 8.80469L6.86196 10.8047C6.92746 10.8702 7.00589 10.9213 7.09224 10.9547C7.17858 10.9882 7.27096 11.0033 7.36347 10.9991C7.45599 10.9949 7.54661 10.9715 7.62957 10.9303C7.71252 10.8892 7.78599 10.8312 7.84529 10.76L11.1786 6.76002Z" fill="white"/></svg>';
              }
              gliderActive = true;
              gliderVariantID = '';
            } else {
              robocapUpgradeGlider.style.display = 'block';
              robocapUpgradeGlider.classList.remove('active');
              
              const gliderAction = robocapUpgradeGlider.querySelector('.upgrade-glider-action');
              if (gliderAction) {
                gliderAction.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_398_3965)"><path d="M8.00431 5.0705V8.0045M8.00431 8.0045V10.9385M8.00431 8.0045H10.9383M8.00431 8.0045H5.07031" stroke="#352B27" stroke-linecap="round" /><path d="M8.00492 15.3382C12.0559 15.3382 15.3399 12.0542 15.3399 8.00315C15.3399 3.95214 12.0559 0.668152 8.00492 0.668152C3.95391 0.668152 0.669922 3.95214 0.669922 8.00315C0.669922 12.0542 3.95391 15.3382 8.00492 15.3382Z" stroke="#352B27" /></g><defs><clipPath id="clip0_398_3965"><rect width="16" height="16" fill="white" /></clipPath></defs></svg>';
              }
              gliderActive = false;
              gliderVariantID = '';
            }
            updatePricing();
          }
        });
      }
    });
  }
});